export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/howItWorks3.4b81cf5c.svg","height":380,"width":592,"blurWidth":0,"blurHeight":0};